import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import EditPanelTarget from './editPanelTarget'
import * as AC from '../../actions/actionCreators'
import * as HELPER from '../../util/helpers'
import { getSetting } from '../../util/helpers'

function mapStateToProps(state) { 
	return {
        actualPanel: state.panel.actualPanel,
        isLoading: state.target.isLoading || state.targetgroup.isLoading || state.panel.isLoading || state.address.isLoading,
        actualTargetgroups: HELPER.generateSpecialtyList(state.target.actualTarget, state.targetgroup.targetgroups),
        errorTarget: state.target.error,
        errorPanelChange: state.panelChange.error,
        targetgroups: state.targetgroup.targetgroups,
        errorPanel: state.panel.error,
        visitorTerritory: state.profile.visitorTerritory,
        addresses: state.address.addressesByLicense,
        isPanelOpen: getSetting(state.setting.settings, "isPanelOpen") === "true",
}};

function mapDispatchToProps(dispatch) {
    return({
        fetchTarget: (license) => { dispatch(AC.TargetLoadingStarted(license) ) },
        fetchPanel: (visitorTerritory) => { dispatch(AC.PanelLoadingStarted(visitorTerritory) ) },
        fetchTargetgroups: () => { dispatch(AC.TargetGroupListLoadingStarted()) },
        fetchTargetAddresses: (license) => { dispatch(AC.AddressListByLicenseLoadingStarted(license) ) },
        savePanelChange: (visitorTerritory, license, frequencyRequest, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu) => { dispatch(AC.PanelChangeModifyTargetStarted(visitorTerritory, license, frequencyRequest, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu)) },
    })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditPanelTarget));